import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  RiHome4Line,
  RiHome4Fill,
  RiBarChart2Line,
  RiBarChart2Fill,
  RiMedalLine,
  RiMedalFill,
  RiDownloadCloud2Line,
  RiDownloadCloud2Fill
} from 'react-icons/ri';
import { useOffline } from '../offline/OfflineContext';
import styles from './AppDock.module.css';

// The one app-shell dock, shared by Dashboard, Insights, Rewards, and
// Settings. The three slots are the product's spine: your library, your
// habit, your trophies. Purchase and FAQ are destinations you visit with
// intent (credit chip, menus), not places you live — they don't get slots.
const DOCK_ITEMS = [
  { to: '/', label: 'Home', icon: RiHome4Line, activeIcon: RiHome4Fill },
  { to: '/insights', label: 'Progress', icon: RiBarChart2Line, activeIcon: RiBarChart2Fill },
  { to: '/rewards', label: 'Rewards', icon: RiMedalLine, activeIcon: RiMedalFill }
];

// Inside the installed app a fourth slot lists what is stored on the device.
const DOWNLOADS_ITEM = { to: '/downloads', label: 'Downloads', icon: RiDownloadCloud2Line, activeIcon: RiDownloadCloud2Fill };

function AppDock() {
  const navigate = useNavigate();
  const location = useLocation();
  const offline = useOffline();
  const items = offline.standalone ? [...DOCK_ITEMS, DOWNLOADS_ITEM] : DOCK_ITEMS;

  return (
    <nav className={styles.bottomNav} aria-label="Main">
      {items.map(({ to, label, icon: Icon, activeIcon: ActiveIcon }) => {
        const isActive = location.pathname === to;
        return (
          <button
            key={to}
            type="button"
            className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
            onClick={() => navigate(to)}
            aria-current={isActive ? 'page' : undefined}
          >
            {isActive ? <ActiveIcon size={24} aria-hidden="true" /> : <Icon size={24} aria-hidden="true" />}
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default AppDock;
